export function readDouble(buffer) {
  return buffer.readDoubleLE();
}